import { gql, MutationResult, useMutation } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { MutationReturnType } from 'basics/types/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const setCiStatusToActiveMutationCall = gql`
  mutation setCiStatusToActive($id: String!, $sendToVeeva: Boolean!) {
      setCiStatusToActive(id: $id, sendToVeeva: $sendToVeeva)
  }
`;

type ApiResultType = {
  setCiStatusToActive: boolean;
};

type UseSetCiStatusToActiveMutation = [
  (id: string) => Promise<MutationReturnType<boolean>>,
  MutationResult<ApiResultType>,
];

export const useSetCiStatusToActiveMutation = (): UseSetCiStatusToActiveMutation => {
  const [setCiStatusToActive, state] = useMutation<ApiResultType>(setCiStatusToActiveMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });
  const flags = useFlags();

  const executeMutation = useCallback(async (id) => {
    try {
      const { data } = await setCiStatusToActive({
        variables: {
          id,
          sendToVeeva: flags.mayaEnableVeevaBiogenlinc1816,
        },
      });
      return { data: !!data?.setCiStatusToActive, error: null };
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'setCiStatusToActive.ts - useSetCiStatusToActiveMutation',
        });

        return { data: false, error: customContext.message as string };
      }

      return { data: false, error: null };
    }
  }, [setCiStatusToActive, flags.mayaEnableVeevaBiogenlinc1816]);

  return [executeMutation, state];
};
